export const STORAGE_ADDRESS_INFO = 'LEQI_ADDRESS'
export const STORAGE_CURR_ADDR = 'CURR_ADDR'

export const ORDER_DELIVERY = {
  'normal': '普通快递',
  'urgent': '加急快递',
}
export const ORDER_STATE = {
  'waiting': '待支付',
  'processing': '待发货',
  'shipping': '待收货',
  'completed': '已完成',
  'refunding': '待退款',
  'refunded': '已退款',
  'canceled': '已取消',
}